import { BaseSelect } from "@/shared/ui/base-select";
import { MenuItem, Stack, Typography } from "@mui/material";
import { useState } from "react";

export type BasePaginationControlProps = {
  page: number;
  perPage: number;
  totalCount: number;
  onPerPageChange?: (perPage: number) => void;
};

export const BasePaginationControl: React.FC<BasePaginationControlProps> = ({
  page,
  perPage,
  totalCount,
  onPerPageChange,
}) => {
  const [value, setValue] = useState(perPage);
  const handleChangePerPage = (perPage: number | "") => {
    if (perPage === "") {
      return;
    }
    setValue(perPage);
    onPerPageChange?.(perPage);
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={{ xs: "space-between", sm: "flex-end" }}
      spacing={2}
    >
      <Typography fontSize={14}>
        {(page - 1) * perPage + 1} - {Math.min(page * perPage, totalCount)} 件 /
        全{` ${totalCount} 件`}
      </Typography>
      <BaseSelect
        type="number"
        value={value}
        size="small"
        sx={{ width: 96 }}
        onChange={handleChangePerPage}
      >
        <MenuItem value={50}>50件</MenuItem>
        <MenuItem value={100}>100件</MenuItem>
      </BaseSelect>
    </Stack>
  );
};
